<template>
    <table class="table table-striped history-table">
        <thead>
            <tr :class="{ 'top-border-0': parentName === 'vacationHistory' }">
                <th>{{ $trans.get("__JSON__.Category") }}</th>
                <th>Feld</th>
                <th>{{ $trans.get("__JSON__.Old Value") }}</th>
                <th>{{ $trans.get("__JSON__.New Value") }}</th>
                <th>{{ $trans.get("__JSON__.User") }}</th>
                <th>{{ $trans.get("__JSON__.Timestamp") }}</th>
                <th>{{ $trans.get("__JSON__.Comment") }}</th>
            </tr>   
        </thead>
        <tbody>
            <template v-for="change in filteredChanges" :key="change.id">
                <tr>
                    <td>                     
                        <div class="d-flex align-items-center">
                            {{ $trans.get(`__JSON__.${change.body}`) }}
                        </div>
                    </td>
                    <td> 
                        <div v-if="change.changes">
                            <div v-for="[key, value] of Object.entries(change.changes)" :key="key">
                                <div v-if="!blacklistChanges.includes(key)">
                                    {{ translations[key] || key }}
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div v-if="change.changes">
                            <div v-for="[key, value] of Object.entries(change.changes)" :key="key">
                                <div v-if="!blacklistChanges.includes(key)">
                                    <span>
                                        {{ getTranslation(change.reference_table, key, value) || "\xa0" }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div v-if="change.changes">
                            <div v-for="[key, value] of Object.entries(change.changes)" :key="key">
                                <div v-if="!blacklistChanges.includes(key)">
                                    <span>
                                        {{ getTranslation(change.reference_table, key, change.modeldata[key]) || "\xa0" }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td v-if="change.user">{{ change.user.name }}</td>
                    <td v-if="!change.user">{{ $trans.get("__JSON__.system") }}</td>
                    <td>{{ formatDateTimeSecondsView(change.created_at) }}</td>
                    <td>{{ change.reason }}</td>
                </tr>
            </template>
        </tbody>
    </table>
</template>

<script>
import {formatDateView, formatDateTimeView, formatDateTimeSecondsView} from "../formatdate";

export default {
    name: "History",
    props: {
        changes: Array,
        absenceTypes: Array,
        locations: Array,
        projects: Array,
        countries: Array,
        countryregions: Array,
        lockerlocations: Array,
        genders: Array,
        divisions: Array,
        worktypes: Array,
        employers: Array,
        teams: Array,
        vacationprofiles: Array,
        salerytypes: Array,
        worktimes: Array,
        bonusprofiles: Array,
        costcentres: Array,
        clients: Array,
        employerrates: Array,
    },
    data() {
        return {
            translations: [],
            blacklistChanges: [
                'workdays',
                'duration_seconds',
                'history_employee',
                'lastchange_user_id',
                'history_project'
            ],
            filteredChanges: [],
            parentName: '',
        };
    },
    mounted() {
        this.parentName = this.$parent?.$options.name;
        this.fetchTranslatedAttributes()
    },    
    watch: {
        changes: {
            handler(newVal) {
                if (this.changes && this.changes.length > 0) {
                    this.parseChanges();
                    this.reference_table = this.changes[0].reference_table;
                    this.filterChanges();
                }   
            },
            immediate: true,
            deep: true,
        },
    }, 
    methods: {
        /**
         * Formats changes so that dates are in the correct format and translations are applied
         * @param referenceTable Reference table of the changes
         * @param key key of the change which is the attribute in the model
         * @param value value of the change
         */        
        formatChange(referenceTable, key, value) {
            if(referenceTable === 'App\\Models\\Stamp' && key === 'project_id'){
                if(!value){
                    return "\xa0";
                }
                const projectName = this.projects.find((element) => element.id == value)?.name || "\xa0";
                const clientName = this.projects.find((element) => element.id == value)?.client?.name;

                if(!clientName){
                    return value;
                }

                return `${clientName} - ${projectName}`;
            }

            if(referenceTable === 'App\\Models\\Employee' && key === 'default_costcentre'){
                if(!value){
                    return "\xa0";
                }                
                const costcentreId = value || "\xa0";
                const costcentreName = this.costcentres.find((element) => element.costcentre == value)?.name;

                if(!costcentreName){
                    return costcentreId;
                }

                return `${costcentreId} - ${costcentreName}`;
            }

            if (!this.isValidDate(value)) {
                const attributesMap = {
                    absence_type_id: this.absenceTypes,
                    location_id: this.locations,
                    project_id: this.projects,
                    country: this.countries,
                    countryregion_id: this.countryregions,
                    locker_location_id: this.lockerlocations,
                    gender_id: this.genders,
                    division_id: this.divisions,
                    worktype_id: this.worktypes,
                    team_id: this.teams,
                    employer_id: this.employers,
                    vacation_profile_id: this.vacationprofiles,
                    salerytype_id: this.salerytypes,
                    worktime_id: this.worktimes,
                    employee_bonus_profile_id: this.bonusprofiles,
                    costcentre_id: this.costcentres,
                    client_id: this.clients,
                    employerrate_id: this.employerrates,
                };

                const attribute = attributesMap[key];
                this.filterSameDate(this.reference_table);

                if (attribute) {
                    return attribute.find((element) => element.id == value)?.name || "\xa0";
                }
                else if (/<\/?[^>]+(>|$)/g.test(value)){
                    return this.stripHtmlTags(value);
                }
                else if (value == 0 || value == 1) {
                    return value == 1 ? 'Ja' : 'Nein';
                }
                else {
                    return value;
                }
            }

            if (referenceTable === 'App\\Models\\Absence' && (key === 'start_at' || key === 'end_at') || key === 'birthday') {
                return formatDateView(value);
            }             
            else {
                return formatDateTimeSecondsView(value);
            }
        },
        /**
         * Filter out changes that aren't relevant
         */
        filterChanges(){
            this.filteredChanges = this.changes.map(change => {
                if (change.changes) {
                    Object.keys(change.changes).forEach(key => {
                        if (this.blacklistChanges.includes(key)) {
                            delete change.changes[key];
                        }
                    });

                    Object.keys(change.changes).forEach(key => {
                        if ( (change.changes[key] == 1 && change.modeldata[key] === true) || (change.changes[key] == 0 && change.modeldata[key] === false) ) {
                            delete change.changes[key];
                        }
                    });

                    Object.keys(change.changes).forEach(key => {
                        if ( !change.changes[key] && change.modeldata[key] == 0 ) {
                            delete change.changes[key];
                        }
                    });

                    Object.keys(change.changes).forEach(key => {
                        if ( !change.changes[key] == 1 && !change.modeldata[key] ) {
                            delete change.changes[key];
                        }
                    });
                }
                return change;
            });

            const createdEntry = this.changes.find(change => change?.body === "Created");

            if(createdEntry) {
                this.filteredChanges = this.filteredChanges.filter(change =>
                    change.body === "Created" || 
                    change.body === "Deleted" || 
                    change.changes && change.changes && Object.keys(change.changes).length > 0 &&
                    change.body === "change" && new Date(change.created_at) > new Date(createdEntry?.created_at)                   
                )
            }
            else {
                this.filteredChanges = this.filteredChanges.filter(change =>
                    change.body === "Created" || 
                    change.body === "Deleted" || 
                    change.changes && change.changes && Object.keys(change.changes).length > 0 &&
                    change.body === "change"                    
                )
            }

            this.filteredChanges.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        },
        /**
         * Filter out changes with the same date
         * @param referenceTable Reference table of the changes
         */
        filterSameDate(referenceTable) {
            this.filteredChanges.forEach(change => {
                if(!change.changes) {
                    return;
                }
                for (var key in change.changes){
                    const value = change.changes[key]; 
                    if (!this.isValidDate(value)) {
                        return;
                    }
                    const modelDataValue = change.modeldata[key];
                    if (referenceTable === 'App\\Models\\Absence' && (key === 'start_at' || key === 'end_at')) {
                        if(value && modelDataValue && formatDateView(value) === formatDateView(modelDataValue)) {  
                            delete change.changes[key];
                        }
                    }   
                    else if (value && modelDataValue && formatDateTimeView(value) === formatDateTimeView(modelDataValue)){
                        delete change.changes[key];
                    }                    
                }            
            });
        },
        /**
         * Check if the value is a string in the format of a date
         * @param value value to be checked
         * @returns {boolean} true if the value is a date
         */
        isValidDate(value) {
            return typeof value === 'string' && (
                /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{6}Z$/.test(value) || 
                /^\d{4}-\d{2}-\d{2}$/.test(value) ||
                /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)
            );
        },
        /**
         * Get the translation of a value
         * @param referenceTable Reference table of the changes
         * @param key key of the change which is the attribute in the model
         * @param value value of the change
         */
        getTranslation(referenceTable, key, value) {
            const formattedValue = this.formatChange(referenceTable, key, value);
            const translationKey = `__JSON__.${formattedValue}`;
            const translation = this.$trans.get(translationKey);
            return translation !== translationKey ? translation : formattedValue;
        },
        formatDateView,
        formatDateTimeView,
        formatDateTimeSecondsView,
        /**
         * Parse changes from string to object
         */
        parseChanges() {
            for (var change of this.changes) {
                if (change.changes && typeof change.changes === 'string' || typeof change.modeldata === 'string') {
                    try {
                        change.changes = JSON.parse(change.changes);
                    } catch (e) {
                        console.warn('Failed to parse changes:', change.changes);
                    }

                    try {
                        change.modeldata = JSON.parse(change.modeldata);
                    } catch (e) {
                        console.warn('Failed to parse modeldata:', change.modeldata);
                    }
                }
            }
        },
        /**
         * Strips the html tags from a string
         * @param text text to be stripped
         */
        stripHtmlTags(text) {
            const div = document.createElement("div");
            div.innerHTML = text;
            return div.textContent || div.innerText || "";
        },
        /**
         * Fetches the translated attributes from the validation language file
         */
        fetchTranslatedAttributes(){
            axios.get('/api/translations')
            .then(response => {
                this.translations = response.data;
            })
            .catch(error => {
                console.error(error);
            });
        },
        hideTooltip(){
            $(".tooltip").css('display', 'none');
        },
    }
}
</script>

<style scoped>
.top-border-0 th {
    border-top: none !important;
}
</style>